import React from 'react';

const DropboxIcon: React.FC = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="dropbox-mask" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <path d="M16 0.183594H0V16.1836H16V0.183594Z" fill="white" />
      </mask>
      <g mask="url(#dropbox-mask)">
        <path
          d="M8.0108 4.42609L4.33938 6.7682L8.0108 9.11031L4.33938 11.4524L0.667969 9.09765L4.33938 6.75554L0.667969 4.42609L4.33938 2.08398L8.0108 4.42609ZM4.32039 12.2057L7.99181 9.86358L11.6632 12.2057L7.99181 14.5478L4.32039 12.2057ZM8.0108 9.09765L11.6822 6.75554L8.0108 4.42609L11.6632 2.08398L15.3346 4.42609L11.6632 6.7682L15.3346 9.11031L11.6632 11.4524L8.0108 9.09765Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default DropboxIcon;
